import {
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import React from 'react';
import { NumericFormat } from 'react-number-format';

export default React.memo(function ProductRowRWindow({
  index,
  style,
  data: { items, onChange, conversation, valuta, selectedValute, listOfValuta },
}) {
  const row = items?.[index];

  return (
    <Grid
      container
      style={style}
      tabIndex={-1}
      columns={{ xs: 12, sm: 12, lg: 12 }}
      className={
        'no-underline bg-white hover:bg-gray-100 border-y border-t-transparent items-center'
      }
    >
      <Grid item xs={0.5} size='small'>
        <div className='px-2 py-0.5'>{index + 1}</div>
      </Grid>
      <Grid item xs={2.5} size='small'>
        <div className='px-2 py-0.5'>{row?.name || ''}</div>
      </Grid>
      <Grid item xs={2} size='small'>
        <div className='px-2 py-0.5'>{row?.category || ''}</div>
      </Grid>
      <Grid item xs={1} size='small'>
        <div className='px-2 py-0.5'>{row?.unit || ''}</div>
      </Grid>
      <Grid item xs={1.5} size='small'>
        <div className='px-2 py-0.5'>
          <NumericFormat
            value={row?.amount ?? ''}
            onChange={(e) => {
              const val = parseFloat(e.target.value.replace(/\s/g, ''));
              onChange(row?.id, 'amount', val);
            }}
            isAllowed={({ floatValue }) =>
              floatValue ? floatValue <= row.max_amount : true
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  max: {row.max_amount}
                </InputAdornment>
              ),
            }}
            customInput={TextField}
            allowNegative={false}
            thousandSeparator=' '
            size='small'
            decimalScale={3}
          />
        </div>
      </Grid>
      <Grid item xs={2.5} size='small'>
        <div className='px-2 py-0.5'>
          <NumericFormat
            value={row?.price || ''}
            onValueChange={(values) => {
              onChange(row?.id, 'price', values?.floatValue || 0);
            }}
            customInput={TextField}
            thousandSeparator=' '
            allowNegative={false}
            decimalScale={3}
            fullWidth
          />
        </div>
      </Grid>
      <Grid item xs={2} size='small'>
        <div className='px-2 py-0.5'>
          <Select
            fullWidth
            onChange={(_, val) =>
              onChange(row?.id, 'isvalute', val?.props?.value)
            }
            value={row?.isvalute}
            key={selectedValute}
          >
            {listOfValuta?.map((opt) => (
              <MenuItem value={opt?.id} key={opt?.id}>
                {opt?.name}
              </MenuItem>
            ))}
          </Select>
        </div>
      </Grid>
    </Grid>
  );
});
